import { useCallback } from 'react';
import { useContext } from '../ContextProvider/context.esm.js';

function useQuery() {
  var _useContext = useContext(),
      _useContext$search = _useContext.search,
      search = _useContext$search.search,
      variables = _useContext$search.variables,
      query = _useContext$search.query,
      config = _useContext$search.config;

  var setQuery = useCallback(function (q) {
    var _variables$set;

    variables.set((_variables$set = {}, _variables$set[config.qParam] = q, _variables$set));
    search(q);
  }, [search, variables]);
  return {
    query: query,
    setQuery: setQuery
  };
}

export default useQuery;
//# sourceMappingURL=index.esm.js.map
